<template>
    <form-row title="Is new owner assuming prior owner's contracts?">
        <div class="flex flex-1 justify-between -mt-4">
            <input-radio-boolean
                name="is_new_owner_assuming_contract"
                v-model="is_new_owner_assuming_contract"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            is_new_owner_assuming_contract: this.commercial.is_new_owner_assuming_contract,
        }
    },
}
</script>
